
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { COMPANY_LIST } from "@/constant";
import {
  searchCustomer
} from "@/api/customer";
import {
  getPiCombinedUnit,
  getSupplierProduct,
  putPiCombinedUnit
} from "@/api/proforma";
import { PiDetail } from "../types";
import { deepClone } from "@/utils/deepClone";
import {Message} from "element-ui";

@Component({
  name: "ModifyDiscounts"
})
export default class extends Vue {
  @Prop({ default: false }) private show: boolean;
  @Prop({ default: "创建组合单位" }) private title: "";
  @Prop({ default: {} }) private selectedItem: {};

  @Watch("show", { immediate: true })
  private async watchData() {
    if ((this.selectedItem as any).id && this.show) {
      this.form = deepClone(this.selectedItem);
      await this.getPiCombinedUnit();
    }
  }

  private form = {} as PiDetail;
  private table = {
    total: 0,
    pageNumber: 1,
    pageSize: 20,
    list: [] as any[]
  };
  public tableCol = [
    {
      label: "华强品名",
      prop: "hqProductName",
      key: "hqProductName",
      show: true,
      disabled: false
    },
    {
      label: "供应商",
      prop: "supplier",
      key: "supplier",
      show: true,
      disabled: false
    },
    {
      label: "接单数量",
      prop: "shipmentQuantity",
      key: "shipmentQuantity",
      show: true,
      disabled: false,
      type: "input"
    },
    {
      label: "下单数量",
      prop: "deliveryQuantity",
      key: "deliveryQuantity",
      show: true,
      disabled: false,
      type: "input"
    },
    {
      label: "组合中文单位",
      prop: "shipmentChineseUnit",
      key: "shipmentChineseUnit",
      show: true,
      disabled: false,
      type: "input"
    },
    {
      label: "供应商中文单位",
      prop: "deliveryChineseUnit",
      key: "deliveryChineseUnit",
      show: true,
      disabled: false,
      type: "input"
    },
    {
      label: "组合英文单位",
      prop: "shipmentEnglishUnit",
      key: "shipmentEnglishUnit",
      show: true,
      disabled: false,
      type: "input"
    },
    {
      label: "供应商英文单位",
      prop: "deliveryEnglishUnit",
      key: "deliveryEnglishUnit",
      show: true,
      disabled: false,
      type: "input"
    }
  ] as any;

  private list = [
    {
      label: "公司",
      prop: "company",
      key: "company",
      type: "select",
      placeholder: "请选择公司",
      clearable: true,
      maxlength: 100,
      rules: {
        required: true,
        message: "请选择公司",
        trigger: "change"
      },
      options: COMPANY_LIST
    },
    {
      label: "客户",
      prop: "customerId",
      key: "customerId",
      type: "select",
      value: "",
      placeholder: "请选择客户",
      remote: true,
      remote_method: this.getCustomer,
      clearable: true,
      options: [],
      rules: {
        required: true,
        message: "请选择客户",
        trigger: "change"
      },
      labelKey: "abbreviation",
      valueKey: "id"
    }
  ];

  private close() {
    this.$emit("update:show", false);
  }

  private open() {
    this.$emit("update:show", true);
  }

  private async submitForm(): Promise<void> {
    this.putPiCombinedUnit();
  }

  private async getCustomer(name = "") {
    const res: any = await searchCustomer({ keyword: name });
    this.list[1].options = res;
  }

  private onSelectionChange(rows: any[]) {
    console.log(rows);
  }

  public async handleDelete(scope) {
    this.$notify({
      title: "成功",
      message: "删除成功",
      type: "success",
      duration: 2000
    });
  }

  // 更新组合单位
  private async putPiCombinedUnit() {
    const {
      hqProductName,
      supplier,
      shipmentQuantity,
      deliveryQuantity,
      deliveryChineseUnit,
      shipmentChineseUnit,
      deliveryEnglishUnit,
      shipmentEnglishUnit
    } = this.form;
    let params = {
      hqProductName,
      supplierAbbr: supplier,
      shipmentQuantity,
      deliveryQuantity,
      deliveryChineseUnit,
      shipmentChineseUnit,
      deliveryEnglishUnit,
      shipmentEnglishUnit
    };
    if (!this.checkQty(shipmentQuantity) ||!this.checkQty(deliveryQuantity)){
      return;
    }
    try {
      await putPiCombinedUnit(this.form.id, params);
      this.$notify({
        title: "成功",
        message: "创建成功",
        type: "success",
        duration: 2000
      });
      this.close();
      this.$emit("success", false);
    } catch {
    }
  }

  private checkQty(qty: any) {
    let message = ""; // 先将输入值转为数字类型（关键步骤）
    const numericQty = Number(qty);

    if (typeof qty === 'string' && qty.trim() === "") { // 处理空字符串
      message = "请填入值";
    } else if (isNaN(numericQty)) { // 处理非数字（如字母、符号）
      message = "请输入数字";
    } else if (!Number.isInteger(numericQty)) { // 处理非整数
      message = "请输入整数";
    } else if (numericQty <= 0) { // 处理非正数
      message = "请输入正整数";
    }
    if (message !== "") {
      Message.error({
        message: message,
        duration: 2000
      });
      return false;
    }
    return true;
  }

  private async getPiCombinedUnit() {
    const res: any = await getPiCombinedUnit(this.form.id);
    this.$set(this.form, "shipmentChineseUnit", res.shipmentChineseUnit || "");
    this.$set(this.form, "shipmentEnglishUnit", res.shipmentEnglishUnit || "");
    this.$set(this.form, "deliveryChineseUnit", res.deliveryChineseUnit || "");
    this.$set(this.form, "deliveryEnglishUnit", res.deliveryEnglishUnit || "");
    this.$set(this.form, "shipmentQuantity", res.shipmentQuantity || 1);
    this.$set(this.form, "deliveryQuantity", res.deliveryQuantity || 1);
    if (!res.deliveryChineseUnit) {
      this.getSupplierProduct(res.supplierId);
    }
  }

  private async getSupplierProduct(supplierId) {
    const res: any = await getSupplierProduct(supplierId, {
      hqProductName: this.form.hqProductName
    });
    this.$set(this.form, "deliveryChineseUnit", res.chineseUnit || "");
    this.$set(this.form, "deliveryEnglishUnit", res.englishUnit || "");
    this.$set(this.form, "shipmentQuantity", 1);
    this.$set(this.form, "deliveryQuantity", 1);
  }
}
